import React, { useContext } from 'react'; 
import {Switch, Redirect} from 'react-router-dom'; 
import { Route } from 'react-router-dom';
import Minimal from './layout/Minimal/Minimal'; 
import Main from './layout/Main/Main'; 
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn'; 
import {AuthContext} from './common/context/auth-context'; 
const Dashboard = React.lazy(()=> import('./pages/Dashboard')); //lazy load code splitting
const ForgotPassword = React.lazy(()=> import('./pages/ForgotPassword')); //lazy load code splitting
const ResetPassword = React.lazy(()=> import('./pages/ResetPassword')); //lazy load code splitting
const Account = React.lazy(()=> import('./pages/Account')); //lazy load code splitting


const Routes = () => {
 const auth = useContext(AuthContext); 
  console.log(auth.isLoggedIn); 
  let routes; 
  let search = window.location.search; //confirm email 
  let params = new URLSearchParams(search);
  let key = params.get('key');
  let dashboard = "/dashboard"; 
  if (key)
  {
    dashboard = "/dashboard?key="+key; //send confirmation key to dashboard if logged in. 
  }

 if (auth.stripeStatus && auth.stripeStatus.status ==='canceled' && auth.isLoggedIn)
 routes= (
  <Switch>
    <Route path = "/account" exact render={(props)=> <Main tenantname={auth.tenant}><Account {...props}/></Main>}/>
    <Redirect to="/account?billing=true"/>
  </Switch>
);
  else if (auth.isLoggedIn) //logged in routes 
   routes= (
    <Switch>
      <Route path = "/dashboard" exact render={(props)=> <Main tenantname={auth.tenant}><Dashboard {...props}/></Main>}/>
      <Route path = "/account" exact render={(props)=> <Main tenantname={auth.tenant}><Account {...props}/></Main>}/>
      <Route path='/docs' component={() => { 
     window.location.href = 'https://docs.mernkit.com'; 
     return null;
}}/>
      <Route path='/mern' component={() => { 
     window.location.href = 'https://mernkit.com'; 
     return null;
}}/>
      <Redirect to={dashboard}/>
    </Switch>
  );


  else
    routes = ( 
      <Switch>
      <Route path = "/sign-in" exact render={(props)=> <Minimal><SignIn {...props}/></Minimal>}/>
      <Route path = "/sign-up" exact render={(props)=> <Minimal><SignUp {...props}/></Minimal>}/>
      <Route path = "/ForgotPassword" exact render={(props)=> <Minimal><ForgotPassword {...props}/></Minimal>}/>
      <Route path = "/resetpw" exact render={(props)=> <Minimal><ResetPassword {...props}/></Minimal>}/>
      <Redirect to="/sign-in"/>
    </Switch>    
    );
  

      
      return routes; 

}

export default Routes; 